import React, { useState, useEffect } from 'react';

import SideBarMenuTab from './SideBarMenuTab';

const SidebarMenu = (props) => {
  const [type1, setType1] = useState('');
  const [type2, setType2] = useState('');
  useEffect(() => {
    if (props.type === 0) {
      setType1('Dealerships');
      setType2('Journey');
    } else if (props.type === 1) {
      setType1('Stories');
      setType2('Report');
    } else if (props.type === 2) {
      setType1('Plans');
      setType2('Collections');
    } else if (props.type === 3) {
      setType1('Setup Auth');
      setType2('Badges');
    } else if (props.type === 4) {
      setType1('Leaderboard');
      setType2('Inapp');
    } else if (props.type === 5) {
      setType1('Custom Group');
      setType2('Rules');
    } else if (props.type === 6) {
      setType1('PX Dashboard');
      setType2('RockED Curriculum');
    } else if (props.type === 7) {
      setType1('ToM');
      setType2('RockED Fuel');
    } else if (props.type === 8) {
      setType1('Topics');
      setType2('Certifications');
    } else if (props.type === 9) {
      setType1('AI Roleplay');
      setType2('Categories');
    } else if (props.type === 10) {
      setType1('Contests');
      setType2('RNP');
    } else if (props.type === 12) {
      setType1('Admin Users');
    } else {
      setType1('Quiz');
    }
  }, []);

  return (
    <div
      style={{
        display: 'inline-flex',
        width: '100%',
      }}
    >
      <SideBarMenuTab type={type1} />
      {type2 !== '' && <SideBarMenuTab type={type2} />}
    </div>
  );
};

export default SidebarMenu;
